if (!customElements.get('header-mega-menu')) {
	class HeaderMegaMenu extends HTMLElement {
		constructor() {
			super()
			this.menu = this.querySelector('.header-megamenu__menu')
			this.announcementBar = document.querySelector('announcement-bar')
			this.icons = this.querySelectorAll('[data-header-megamenu-icon]')

			// Search
			this.predictiveSearch = document.getElementById('predictive-search')
			this.closeSearchButton = this.querySelector('[data-close-search-button]')

			this.isTransparent = this.hasAttribute('transparent')
		}

		connectedCallback() {
			this.setEventListeners()
		}

		setEventListeners() {
			// Attach menu button listener once
			this.menuButton = this.menu?.querySelector('.header-megamenu__menu-button')
			if (this.menuButton && !this._menuListenerAttached) {
				this.menuButton.addEventListener('click', this.onMenuButtonClick, { passive: false })
				this._menuListenerAttached = true
			}

			if (this.announcementBar) {
				document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`)
				document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`)
			}

			document.querySelectorAll('.header-megamenu__icon--search')?.forEach(icon => {
				icon.addEventListener(
					'click',
					() => {
						this.openSearch()
						this.active()
					},
					{ passive: false }
				)
			})

			document.querySelector('[data-close-search-button]')?.addEventListener('click', () => {
				this.closeSearch()
				this.deactive()
			})

			window.addEventListener('resize', () => {
				if (this.announcementBar) {
					document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`)
					document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`)
				}
			})

			if (this.isTransparent) {
				window.addEventListener('scroll', () => {
					if (window.scrollY > 100) {
						this.classList.remove('header-megamenu--transparent')
					} else {
						this.classList.add('header-megamenu--transparent')
					}
				})
			}
		}

		disconnectedCallback() {
			if (this.menuButton && this._menuListenerAttached) {
				this.menuButton.removeEventListener('click', this.onMenuButtonClick)
				this._menuListenerAttached = false
			}
		}

		onMenuButtonClick = event => {
			// Prevent native toggling/double-fire on Safari
			event?.preventDefault?.()
			event?.stopPropagation?.()
			event?.stopImmediatePropagation?.()
			if (this.menu?.hasAttribute('open')) {
				this.close()
			} else {
				this.open()
			}
		}

		open() {
			this.menu.setAttribute('open', true)
			this.active()
			document.body.style.overflow = 'hidden'
			this.closeSearch()
		}

		close() {
			this.menu.removeAttribute('open')
			this.deactive()
			document.body.style.overflow = 'auto'
		}

		active() {
			this.setAttribute('active', true)
		}

		deactive() {
			this.removeAttribute('active')
		}

		openSearch() {
			if (!this.predictiveSearch) return

			this.icons.forEach(icon => {
				icon.classList.add('hidden')
			})
			this.closeSearchButton.classList.remove('hidden')
			this.predictiveSearch.open()
			this.active()
		}

		closeSearch() {
			if (!this.predictiveSearch) return
			this.icons.forEach(icon => {
				icon.classList.remove('hidden')
			})
			this.closeSearchButton.classList.add('hidden')
			this.predictiveSearch.close()
			this.deactive()
		}

		setActiveMegamenu(index) {
			this.activeMegamenu = index
		}
	}

	customElements.define('header-mega-menu', HeaderMegaMenu)
}

if (!customElements.get('mega-menu')) {
	class MegaMenu extends HTMLElement {
		constructor() {
			super()
			this.id = this.getAttribute('data-block-id')
			this.headerMegaMenu = this.closest('header-mega-menu')
			this.openButton = this.querySelector('.header-megamenu__megamenu__title')
			this.backButton = this.querySelector('.header-megamenu__megamenu__content__back-button')
		}

		connectedCallback() {
			this.setEventListeners()
		}

		setEventListeners() {
			if (this.openButton !== null && this.openButton !== undefined) {
				this.openButton.addEventListener('click', () => {
					this.open()
				})
			}

			if (this.backButton !== null && this.backButton !== undefined) {
				this.backButton.addEventListener('click', () => {
					this.close()
				})
			}

			if (this.headerMegaMenu) {
				this.addEventListener('mouseenter', () => {
					this.headerMegaMenu.closeSearch()
				})
			}
		}

		open() {
			this.setAttribute('open', true)
		}

		close() {
			this.removeAttribute('open')
		}
	}

	customElements.define('mega-menu', MegaMenu)
}
